import _ from 'lodash';
import * as Backbone from "backbone";
import template_SelPanSettingsView from './SelPanResetSettingsView.ejs';

export const SelPanResetSettingsView = Backbone.View.extend({
	className: 'SelPanResetSettingsView',
	events: {
		'click [data-invoke="toggleAutoSelect"]': 'toggleAutoSelect',
		'click [data-invoke="resetSettings"]': 'resetSettings'
	},
	initialize: function (options) {
		this.selpan = options.selpan;
		this.listenTo(this.selpan.collection, 'choiceModeChanged', this.render);
		this.listenTo(this.selpan.status, 'change:autoSelect', this.render);
		this.render();
	},
	toggleAutoSelect() {
		this.selpan.status.set({autoSelect: !this.selpan.status.get('autoSelect')});
	},
	resetSettings() {
		this.selpan.resetSettings();
		_.each(this.selpan.collapsibleViews, v => v.resetSettings());
	},
	render: function () {
		this.$el.empty();
		this.$el.append([template_SelPanSettingsView({
			singleChoiceMode: this.selpan.collection.isSingleChoiceMode(),
			autoSelect: this.selpan.status.get('autoSelect')
		})]);
	}
});
